import classnames from 'classnames';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { prettyFloatMoney } from '@/helpers/utils';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { MoneyField } from '@/webkit/form/MoneyField';
import { useGetFundraisingStatus } from '@/query/queries/fundraising/useGetFundraisingStatus';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

const id = MODAL_IDS.set_desired_amount;

const DEFAULT_MIN = 25;

const VALIDATION_SCHEMA = (t, min) =>
  Yup.object().shape({
    amount: Yup.number()
      .min(min, t('set_desired_amount_modal.minimal_amount', { min: prettyFloatMoney(min) }))
      .required(t('set_desired_amount_modal.new_funds_required')),
  });

export const SetDesiredAmountModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

const Modal = ({ amount, onChange }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation('modal');
  const { data: status } = useGetFundraisingStatus();

  const onSubmit = values => {
    onChange(values.amount);
    closeModal(id);
  };

  const { values, touched, errors, setFieldValue, handleSubmit } = useFormik({
    validationSchema: VALIDATION_SCHEMA(t, status?.min_goal || DEFAULT_MIN),
    onSubmit,
    initialValues: {
      amount,
    },
  });

  const content = (
    <form onSubmit={handleSubmit} className={s.modal}>
      <h1 className="f-hero-h5">{t('set_desired_amount_modal.set_desired_amount')}</h1>
      <p className="f-small-regular">{t('set_desired_amount_modal.set_amount_description')}</p>
      <MoneyField
        isFloat
        label={t('set_desired_amount_modal.enter_desired_amount')}
        name="group_a_amount"
        value={values.amount}
        onChange={value => setFieldValue('amount', value)}
        error={touched.amount && errors.amount}
        onClear={() => setFieldValue('amount', '')}
        className={s.input}
      />
      <button
        type="submit"
        className={classnames(r.black_large, s.btn_save)}
        onSubmit={handleSubmit}
      >
        {t('set_desired_amount_modal.save')}
      </button>
    </form>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
